import React from 'react';
import { createRoot } from 'react-dom/client';
import {
  defaultStackParser,
  replayIntegration,
  makeFetchTransport,
  browserTracingIntegration,
  init,
  setUser,
} from '@sentry/browser';

import App from './App';
import { isDev, isStage } from 'helpers';

import { PROD, STAGE } from 'consts';

if (!isDev) {
  const email = sessionStorage.getItem('profileEmail');

  setUser({ email: email || '' });

  init({
    dsn: 'https://fc6d3f6979734033a03f1f97ec7bc82e@sentry.prd01.samoletgroup.ru/83',
    replaysSessionSampleRate: isStage ? 1 : 0.1,
    replaysOnErrorSampleRate: 1.0,
    transport: makeFetchTransport,
    stackParser: defaultStackParser,
    integrations: [
      browserTracingIntegration(),
      replayIntegration({ maskAllText: false, blockAllMedia: false }),
    ],
    environment: isStage ? STAGE : PROD,
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: isStage ? 1 : 0.1,
  });
}

const root = createRoot(document.getElementById('root') as HTMLElement);

root.render(<App />);
